export default __webpack_public_path__ + "static/media/nike-W.8157ce73.png";